import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { GtmService } from 'app/services/gtm.service';

@Component({
    selector: 'app-grant-card',
    standalone: true,
    imports: [CommonModule],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './grant-card.component.html',
})
export class GrantCardComponent {
    @Input() mitiProduct: any = {};
    @Input() selectedLanguage: string = 'en';

    constructor(private router: Router, private _gtmService: GtmService) {}

    goToDetails() {
        const slug = this.mitiProduct.productName
            .replaceAll('(', '')
            .replaceAll(')', '')
            .replaceAll(' ', '-')
            .toLowerCase();
        this.router.navigate([`/grants/${slug}`]);
    }
}
